import { Component } from '@angular/core';

@Component({
  selector: 'htc-shiny-button',
  templateUrl: './shiny-button.component.html',
  styleUrls: ['./shiny-button.component.scss'],
  standalone: false,
})
export class ShinyButtonComponent {}
